import React from 'react';
import { TPaginationParams } from "Pages/GMS/Performance/analytics";
import { PropsWithChildren, createContext, useContext, useState } from "react";
import { AppContext } from "Context/AppContext";
import { DefaultModelsType, TAppletInfo, TestDurationResponse, TModel, TModelData, TPayload, TScoreWeightage, TUpdateTest } from '../types/ab';

export const ABContext = createContext<any>(undefined);

export const ABContextProvider = ({ children }: PropsWithChildren) => {
    const appContext = useContext(AppContext);
    const industryId = appContext.get_selected_industry() && appContext?.get_selected_industry()?.id;
    const [paginationParams, setPaginationParams] = useState<TPaginationParams>({ pageNumber: 1, pageSize: 10 });
    const [disableButton, setDisableButton] = useState<boolean>(false);
    const [selectedApplet, setSelectedApplet] = useState<string | null>(null);
    const DEFAULT_METRIC = "Revenue";
    const initialUpdateTest: TUpdateTest = { id: "", name: "", metric: "", win_threshold: 0, score_weightage: [], applets: [{ applet: "", applet_id: "", applet_name: "", models: [], },], };
    const initialPayload: TPayload = {
        applets: [] as TAppletInfo[],
        channel: '',
        metric: 'Revenue',
        name: '',
        score_weightage: [] as TScoreWeightage[],
        shopping_cycle: '',
        test_duration: 1,
        win_threshold: 0,
        is_auto_stop: true
    };

    const [updateTest, setUpdateTest] = useState<TUpdateTest>(initialUpdateTest);
    const [appletInfo, setAppletInfo] = useState<TAppletInfo | null>(null);
    const [selectedMetric, setSelectedMetric] = useState<string | null>(null);
    const [models, setModels] = useState<TModel[]>([]);
    const [modelData, setModelData] = useState<TModelData[]>([]);

    const [testDurationResponse, setTestDurationResponse] = useState<TestDurationResponse | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [payload, setPayload] = useState<TPayload>();
    const [payloadNetworkCopy, setPayloadNetworkCopy] = useState<TPayload>(initialPayload);
    const [testData, setTestData] = useState<any>(null)
    const [selectedModelId, setSelectedModelId] = useState<string>("")
    const [defaultModels, setDefaultModels] = useState<DefaultModelsType>({});
    const [liveApplets, setLiveApplets] = useState<string[]>([]);

    const clearData = () => {
        setModels([]);
        setSelectedMetric(null);
        setSelectedApplet(null);
        setPayload(initialPayload);
        setLiveApplets([]);
        setDefaultModels({});
        setSelectedModelId("");
        setTestData(null);
        setTestDurationResponse(null);
        setModelData([]);
        setAppletInfo(null);
    }

    return (
        <ABContext.Provider value={
            {
                paginationParams,
                setPaginationParams,
                setDisableButton,
                disableButton,
                industryId,
                selectedApplet,
                setSelectedApplet,
                selectedMetric,
                setSelectedMetric,
                updateTest,
                setUpdateTest,
                appletInfo,
                setAppletInfo,
                testDurationResponse,
                setTestDurationResponse,
                clearData,
                isLoading,
                setIsLoading,
                payload,
                setPayload,
                testData,
                setTestData,
                selectedModelId,
                setSelectedModelId,
                models,
                setModels,
                modelData,
                setModelData,
                payloadNetworkCopy,
                setPayloadNetworkCopy,
                DEFAULT_METRIC,
                defaultModels,
                setDefaultModels,
                liveApplets,
                setLiveApplets
            }}>
            {children}
        </ABContext.Provider>
    );
}
